const variables = {
  fullStarColor: '#b11',
  emptyStarColor: '#e3e4e4',
  strokeColor: '#b11',
  shareCartSenderNameLength: 71,
};

export default variables;



// WEBPACK FOOTER //
// ./src/vanity-fair/variables.js